import {
  SET_SELECTED_STATUS_ACTION,
  SET_SEARCH_TEXT_ACTION,
  SET_EMPRESA_ACTION,
  SET_CENTRO_CUSTO_ACTION,
  SET_PRODUTO_ACTION,
  SET_PROJETO_ACTION,
  SET_RESPONSAVEL_ACTION,
  SET_DATA_INICIAL_ACTION,
  SET_DATA_FINAL_ACTION,
  SET_DATA_FATURAMENTO_INICIAL_ACTION,
  SET_DATA_FATURAMENTO_FINAL_ACTION,
  SET_FILTER_BY_SAVING_ACTION,
  SET_GRUPO_ACTION,
  SET_FORNECEDOR_ACTION,
} from './actions.type';
import {
  SET_SELECTED_STATUS,
  SET_SEARCH_TEXT,
  SET_EMPRESA,
  SET_CENTRO_CUSTO,
  SET_PRODUTO,
  SET_PROJETO,
  SET_RESPONSAVEL,
  SET_DATA_INICIAL,
  SET_DATA_FINAL,
  SET_DATA_FATURAMENTO_INICIAL,
  SET_DATA_FATURAMENTO_FINAL,
  SET_FILTER_BY_SAVING,
  SET_GRUPO,
  SET_FORNECEDOR,
} from './mutations.type';

export default {
  [SET_SELECTED_STATUS_ACTION](context, status) {
    context.commit(SET_SELECTED_STATUS, status);
  },
  [SET_SEARCH_TEXT_ACTION](context, text) {
    context.commit(SET_SEARCH_TEXT, text);
  },
  [SET_EMPRESA_ACTION](context, empresa) {
    context.commit(SET_EMPRESA, empresa);
  },
  [SET_CENTRO_CUSTO_ACTION](context, centroCusto) {
    context.commit(SET_CENTRO_CUSTO, centroCusto);
  },
  [SET_PRODUTO_ACTION](context, produto) {
    context.commit(SET_PRODUTO, produto);
  },
  [SET_PROJETO_ACTION](context, projeto) {
    context.commit(SET_PROJETO, projeto);
  },
  [SET_RESPONSAVEL_ACTION](context, responsavel) {
    context.commit(SET_RESPONSAVEL, responsavel);
  },
  [SET_DATA_FINAL_ACTION](context, dataFinal) {
    context.commit(SET_DATA_FINAL, dataFinal);
  },
  [SET_DATA_INICIAL_ACTION](context, dataInicial) {
    context.commit(SET_DATA_INICIAL, dataInicial);
  },
  [SET_DATA_FATURAMENTO_INICIAL_ACTION](context, dataFaturamentoInicial) {
    context.commit(SET_DATA_FATURAMENTO_INICIAL, dataFaturamentoInicial);
  },
  [SET_DATA_FATURAMENTO_FINAL_ACTION](context, dataFaturamentoFinal) {
    context.commit(SET_DATA_FATURAMENTO_FINAL, dataFaturamentoFinal);
  },
  [SET_FILTER_BY_SAVING_ACTION](context, bool) {
    context.commit(SET_FILTER_BY_SAVING, bool);
  },
  [SET_GRUPO_ACTION](context, grupo) {
    context.commit(SET_GRUPO, grupo);
  },
  [SET_FORNECEDOR_ACTION](context, fornecedor) {
    context.commit(SET_FORNECEDOR, fornecedor);
  },
};
